import { pathBuilder } from 'config/paths/index';

export const root = '/admin/company/notifications';
export default pathBuilder(root);
